module.exports = __webpack_public_path__ + "media/Trazar_camino.e3408f5d.mp4";